import { render, staticRenderFns } from "./CalendarEventCard.vue?vue&type=template&id=73f5b31c&scoped=true&"
import script from "./CalendarEventCard.vue?vue&type=script&lang=js&"
export * from "./CalendarEventCard.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventCard.vue?vue&type=style&index=0&id=73f5b31c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5b31c",
  null
  
)

export default component.exports